module.exports = __webpack_public_path__ + "img/dcmm_20.d5beae44.png";